import { createSlice } from '@reduxjs/toolkit';

export interface IVisibleGrommets {
  isInProgressConfiguration: boolean;
  resetDialog: boolean;
}

const initialState: IVisibleGrommets = {
  isInProgressConfiguration: false,
  resetDialog: false,
};

const grommetsSlice = createSlice({
  name: 'grommets',
  initialState,
  reducers: {
    setInProgressConfiguration: (state, action) => {
      state.isInProgressConfiguration = action.payload;
    },
    displayResetDialog: (state, action) => {
      state.resetDialog = action.payload;
    },
  },
});

export const { setInProgressConfiguration, displayResetDialog } =
  grommetsSlice.actions;
export default grommetsSlice.reducer;
